import React, { useState, useEffect } from 'react'
import { DivTag } from '../../../Components/Tags/Tags'
import Header from '../../../Components/Header'
import Seo from '../../../Components/SeoComponent/Seo'
import { HeadTag, InputField } from '../../../Components/Tags/Tags'
import { showSuccessToast, showErrorToast } from '../../../utils/toastUtils'
import GaugeChart from 'react-gauge-chart'
import { checkScorePrefillService, V2VerifyMobile } from '../../../Services/EquifaxCScore/highmark'
import html2pdf from 'html2pdf.js';
import { CreditScoreDataPrefill, equifaxData, EV2MobileVerify } from '../EquifaxCrScorev2/data'
import Loader from '../../../Loader'
import { fetchProfile } from '../../../Services/profile/profileservice'
import { FaHandPointLeft } from "react-icons/fa";
import { Link } from 'react-router-dom'

const CheckScorePrefill = () => {
  const [firstName, setFirstName] = useState('');
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [mobile, setMobile] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [creditScore, setCreditScore] = useState(0);
  const [profileData, setProfileData] = useState([]);
  const [Equifaxv2Report, setEquifaxv2Report] = useState(null);
  const [Equifaxv2Error, setEquifaxv2Error] = useState(null);
  const [submittedName, setSubmittedName] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [isModalOpenMobile, setIsModalOpenMobile] = useState(false);
  const [mobileResponseData, setMobileResponseData] = useState(null);
  const [afterVerifyMobPan, setAfterVerifyMobPan] = useState('');
  const [triggerVerifyContine, setTriggerVerifyContinue] = useState('');
  const [afterMobName, setAfterMobName] = useState('');
  const [isVerifyDisabled, setIsVerifyDisabled] = useState(
    sessionStorage.getItem("verifyClicked") === "true"
  );

  // NEW: Add state for score check mode
  const [scoreCheckMode, setScoreCheckMode] = useState('manual'); // 'direct' or 'manual'
  const [isMobileVerified, setIsMobileVerified] = useState(false);

  const maxScore = 900;



const validateForm = () => {
  const newErrors = {};

  // First Name
  if (!firstName.trim()) {
    newErrors.firstName = 'First name is required';
  }

  // Last Name
//   if (!lastName.trim()) {
//     newErrors.lastName = 'Last name is required';
//   }

  // Mobile number required
  if (!mobile.trim()) {
    newErrors.mobile = 'Mobile number is required';
  }
  // Mobile format validation
  else if (!/^[6-9]\d{9}$/.test(mobile)) {
    newErrors.mobile = 'Enter a valid 10-digit mobile number';
  }
  // Manual mode mobile verification
  else if (scoreCheckMode === 'manual' && !isMobileVerified) {
    newErrors.mobile = 'Please verify mobile number first for manual check';
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};



  const handlesubmit = async () => {
    try {
      // Validate the form first
      const isValid = validateForm();
      if (!isValid) {
        setEquifaxv2Report(null);
        setEquifaxv2Error(null)
        return;
      }
      setShowLoader(true);
      await CheckScore();

      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
    } catch (error) {
      console.error('Error submitting data:', error);
      showErrorToast('Validate the Required Field');
      setShowLoader(false);
    }
  };

  async function CheckScore() {
    try {
      setShowLoader(true);
      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_number: mobile,
        name: name,
      };

      const response = await checkScorePrefillService(payload);

      if (response.status === 403 && response.data.message === "Invalid or deactivated API key.") {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return
      }

      if (response.status === 422 && response.data.message === "Insufficient balance in wallet.") {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance in wallet.");
        return
      }
      if (response.status === 422 && response.data.message === "User not authorized to access this service.") {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");
        return
      }

      const statusCode = response?.status?.code ?? response?.status;
      const statusMsg = response?.status?.message ?? response?.message;
      const report = response?.data;
      const score = report?.score;

      if (statusCode === 200) {
        setEquifaxv2Report(report);      
        const numericScore = Number(score);
        setCreditScore(isNaN(numericScore) ? 0 : numericScore);
        setSubmittedName(firstName);
        setName('');
        setFirstName('');
        setMobile('');
        setIsMobileVerified(false); // Reset verification status
        showSuccessToast(statusMsg ?? 'Credit score fetched successfully.');
      } else {
        setEquifaxv2Error(response?.error ?? report ?? {});
        setEquifaxv2Report(null);
        showErrorToast(
          response?.data?.error?.credit_report_message?.message   
          ?? statusMsg                                           
          ?? 'Something went wrong.'
        );
      }
    } catch (err) {
      console.error('Error in Score:', err);
      setEquifaxv2Report(null);
      setEquifaxv2Error(err);
      showErrorToast('Something went wrong.');
    } finally {
      setShowLoader(false);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    async function fetchProfileData() {
      try {
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error('Error fetching profile data', error);
      }
    }
    fetchProfileData();
  }, []);

  const handleVerifyMobile = async () => {
    const newErrors = {};
    // Only validate mobile
    if (!mobile.trim()) {
      newErrors.mobile = "Mobile is required";
    } 

     // First Name
  if (!firstName.trim()) {
    newErrors.firstName = 'First Name is required';
  } 

  if (!lastName.trim()) {
    newErrors.lastName = 'Last Name is required';
    }


    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setShowLoader(true);
      setIsVerifyDisabled(true);
      sessionStorage.setItem("verifyClicked", "true");
      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_number: mobile,
        first_name: firstName,
        last_name: lastName,
      };

      const response = await V2VerifyMobile(payload);
      if (response.status === 403 && response.data.message === "Invalid or deactivated API key.") {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return
      }

      if (response.status === 422 && response.data.message === "Insufficient balance in wallet.") {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance.");
        return
      }

      if (response.status === 422 && response.data.message === "User not authorized to access this service.") {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");
        return
      }

      setMobileResponseData(response || response?.data || response?.data?.data);
      if (response?.data?.result !== null) {
        setIsMobileVerified(true); // Set verification status to true
        showSuccessToast(response?.status?.message || response?.message || "Consumer Details Fetched");
      } else {
        setIsMobileVerified(false);
        showErrorToast(response?.status?.message || response?.message || "No Records Found");
      }

      setShowLoader(false);
      setIsLoading(false);
      setIsVerifyDisabled(false);
      setIsModalOpenMobile(true);
    } catch (error) {
      showErrorToast("Error verifying Consumer:", error);
      setIsVerifyDisabled(false);
      setIsMobileVerified(false);
      setShowLoader(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    sessionStorage.removeItem("verifyClicked");
  }, []);

  const VerifyContinue = () => {
    setTriggerVerifyContinue(true);
    setIsModalOpenMobile(false);
  };

  useEffect(() => {
    if (triggerVerifyContine) {
      if (afterMobName) {
        const name = afterMobName || '';
        const nameParts = name.trim().split(' ');
        const firstNameFromName = nameParts[0] || '';
        const lastNameFromName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
        setFirstName(firstNameFromName);
        setLastName(lastNameFromName);
      }

      // Reset trigger
      setTriggerVerifyContinue(false);
    }
  }, [triggerVerifyContine, afterVerifyMobPan, afterMobName]);

  // NEW: Handle mode change and reset verification status
  const handleModeChange = (mode) => {
    setScoreCheckMode(mode);
    setIsMobileVerified(false);
    setErrors({});
  };


  return (
    <>
      <Seo />
      {showLoader && <Loader />}

      <Header heading='Credit Score Check Prefill' />

{/* NEW: Radio buttons for selecting score check mode */}
<DivTag className="flex justify-center items-center gap-6 bg-white mt-2 shadow-md rounded-md p-4">
  <HeadTag className="text-lg font-bold">Select Score Check Mode:</HeadTag>
  
  <label
  className="flex items-center gap-2 cursor-pointer">
  <input
    type="radio"
    name="scoreCheckMode"
    value="direct"
    checked={scoreCheckMode === 'direct'}
    onChange={() => handleModeChange('direct')}
    className="w-4 h-4 cursor-pointer"
  />
  <span className="text-md font-medium">
    Direct Score Check
  </span>
</label>

<label className="flex items-center gap-2 cursor-pointer">
  <input
    type="radio"
    name="scoreCheckMode"
    value="manual"
    checked={scoreCheckMode === 'manual'}
    onChange={() => handleModeChange('manual')}
    className="w-4 h-4 cursor-pointer"
  />
  <span className="text-md font-medium">
    Manual Score Check
  </span>
</label>
</DivTag>


<DivTag className="flex flex-wrap justify-center items-start gap-2 bg-white mt-2 shadow-md rounded-md p-4">
  {/* Mobile Section */}
  <DivTag className="flex flex-col">
    <div className="flex items-center justify-between mb-1">
      <HeadTag className="text-md font-serif">
        Mobile <strong className="text-red-700">*</strong>
      </HeadTag>
      {scoreCheckMode === 'manual' && isMobileVerified && (
        <button
          type="button"
          onClick={() => setIsModalOpenMobile(true)}
          className="text-sm bg-green-600 text-white px-2 py-1 rounded hover:bg-green-700"
        >
          View Details
        </button>
      )}
    </div>

    <InputField
      type="text"
      placeholder="Enter Mobile"
      className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
      name="mobile"
      id="mobile"
      value={mobile}
      onChange={(e) => {
        setMobile(e.target.value);
        setIsMobileVerified(false); // Reset verification when mobile changes
      }}
    />

    {errors.mobile && (
      <p className="text-red-600 text-sm font-mono mt-1">{errors.mobile}</p>
    )}

    {isModalOpenMobile && (
      <MobileDataModal
        setAfterMobName={setAfterMobName}
        mobileResponseData={mobileResponseData}
        VerifyContinue={VerifyContinue}
        onClose={() => setIsModalOpenMobile(false)}
      />
    )}
  </DivTag>

{/* First / Full Name */}
<DivTag className="flex flex-col">
  <HeadTag className="text-md font-serif mb-1">
    {scoreCheckMode === "direct" ? "Name" : "First Name"}{" "}
    <strong className="text-red-700">*</strong>
  </HeadTag>

  <input
    type="text"
    id={scoreCheckMode === "direct" ? "name" : "first_name"}
    name={scoreCheckMode === "direct" ? "name" : "first_name"}
    value={scoreCheckMode === "direct" ? name : firstName}
    className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-60"
    placeholder={`Enter ${scoreCheckMode === "direct" ? "Name" : "First Name"}`}
    onChange={(e) => {
      if (scoreCheckMode === "direct") setName(e.target.value);
      else setFirstName(e.target.value);
    }}
    required
  />

  {(scoreCheckMode === "direct"
    ? errors.name
    : errors.firstName) && (
    <p className="text-red-600 text-sm font-mono mt-1">
      {scoreCheckMode === "direct"
        ? errors.name
        : errors.firstName}
    </p>
  )}
</DivTag>

{/* Last Name – Show Only in Manual Mode */}
{scoreCheckMode === "manual" && (
  <DivTag className="flex flex-col">
    <HeadTag className="text-md font-serif mb-1">
      Last Name <strong className="text-red-700">*</strong>
    </HeadTag>

    <input
      type="text"
      id="last_name"
      name="last_name"
      value={lastName}
      className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-60"
      placeholder="Enter Last Name"
      onChange={(e) => setLastName(e.target.value)}
      required
    />
    {errors.lastName && (
      <p className="text-red-600 text-sm font-mono mt-1">{errors.lastName}</p>
    )}
  </DivTag>
)}


{/* Conditional Button Rendering - Verify or Check Score */}
<div className="flex justify-center">
  {scoreCheckMode === 'manual' && !isMobileVerified ? (
    // Show Verify Mobile button in Manual mode when not verified
    <button
      type="button"
      onClick={handleVerifyMobile}
      disabled={isVerifyDisabled}
      className={`rounded-md bg-green-600 text-white mt-7 mb-1 py-1 px-4 hover:bg-green-700 ${
        isVerifyDisabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >
      {isVerifyDisabled ? 'Verifying...' : 'Verify Mobile'}
    </button>
  ) : (
    // Show Check Score button in Direct mode or after verification in Manual mode
    <button
      className={`rounded-md bg-blue-700 text-white mt-7 mb-1 px-4 py-1 hover:bg-blue-800 ${
        isLoading ? 'opacity-50 cursor-not-allowed' : ''
      }`}
      onClick={handlesubmit}
      disabled={isLoading}
    >
      {isLoading ? 'Checking...' : 'Check Score'}
    </button>
  )}
</div>

</DivTag>





      <div className="flex justify-center items-center space-x-1">
        <p className="text-xl text-black font-medium">Powered By</p>
        <img
          src="https://imgs.search.brave.com/sNRNqpIsIGVhKh1PerKy_ASdFIl6gCXnOq9EsgTjq1M/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWdz/LnNlYXJjaC5icmF2/ZS5jb20vZEROVGNU/ZVhrTGVCMmlmZG5B/ZndtbUFyNlZpalZR/dzgtUzhZVVRYV3NG/TS9yczpmaXQ6NTAw/OjA6MDowL2c6Y2Uv/YUhSMGNITTZMeTkz/ZDNjdS9iRzluYnk1/M2FXNWxMMkV2L2JH/OW5ieTlGZUhCbGNt/bGgvYmk5RmVIQmxj/bWxoYmkxTS9iMmR2/TG5kcGJtVXVjM1pu"
          alt="Experian Logo"
          className="w-20 h-auto"
        />
      </div>

      {Equifaxv2Report || Equifaxv2Error ? (
        <div className="flex flex-col p-4 bg-white shadow-inner md:mt-1 shadow-blue-600 rounded-md">
          <span className='text-center font-bold md:text-xl'>
            Hey {Equifaxv2Report?.name || Equifaxv2Error?.data?.name}!
          </span>
          <h2 className="text-xl md:text-xl font-semibold text-center">Your Credit Score</h2>

          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8 md:mt-2 mt-3 relative">
            {/* Gauge Chart Section */}
            <div className="w-full md:w-[400px] relative md:mt-10">
              <span className="text-red-500 md:font-bold absolute md:top-[20px] md:left-10 md:mt-16 -rotate-70 top-[60px] left-5">Poor</span>
              <span className="text-yellow-400 md:font-bold absolute md:left-[104px] md:mt-1 -rotate-26 left-[69px] top-[-7px]">Average</span>
              <span className="text-orange-600 md:font-bold absolute md:left-60 md:mt-0 md:rotate-20 left-[12rem] mt-[-9px] rotate-20">Good</span>
              <span className="text-green-800 md:font-bold absolute md:top-[20px] md:ml-[19.5rem] md:mt-16 rotate-70 ml-[16rem] mt-[3.5rem]">Excellent</span>

              <GaugeChart
                id="gauge-chart1"
                nrOfLevels={3}
                percent={creditScore / maxScore}
                needleColor="#00008b"
                needleBaseColor="red"
                textColor="transparent"
                arcsLength={[0.3, 0.3, 0.3, 0.3]}
                colors={['#cc0000', '#e6e600', '#cc6600', '#009900']}
              />

              <p className="text-black font-bold text-xl md:text-2xl absolute bottom-12 md:bottom-[5.5rem] left-1/2 transform -translate-x-1/2">
                {creditScore}
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-1">
            {/* Personal Details Card */}
            <div className="flex-1 border rounded-lg p-6 bg-white shadow">
              <h2 className="text-lg font-bold mb-2">Personal Details:</h2>
              <ul className="text-sm md:text-base space-y-1">
                <li><strong>Name:</strong> {Equifaxv2Report?.name}</li>
                <li><strong>Mobile:</strong> {Equifaxv2Report?.mobile}</li>
                <li><strong>Email:</strong> {Equifaxv2Report?.email_info?.email || ""}</li>
                <li><strong>PAN:</strong> {Equifaxv2Report?.identity_info?.identity_info?.identity_info || ""}</li>
                <li><strong>DOB:</strong> {Equifaxv2Report?.personal_info?.dob}</li>
                <li><strong>Gender:</strong> {Equifaxv2Report?.personal_info?.gender}</li>
                <li><strong>Age:</strong> {Equifaxv2Report?.personal_info?.age}</li>
                <li><strong>Occupation:</strong> {Equifaxv2Report?.personal_info?.occupation}</li>
              </ul>
            </div>

            <div className="flex-1 border p-2 rounded">
              <h2 className="text-lg font-bold mb-2 text-center">Addresses</h2>

              <table className="w-full text-sm">
  <tbody>
    {Equifaxv2Report?.address_info?.map((addr, index) => (
      <tr key={index} className="border-b">
        <td className="font-medium pr-2 align-top w-28">
          Address {index + 1}:
        </td>
        <td>
          {addr?.address && <span>{addr.address}, </span>}
          {addr?.state && <span>{addr.state}, </span>}
          {addr?.postal && <span>{addr.postal}</span>}
          {addr?.type && (
            <span className="text-blue-700 ml-1">({addr.type})</span>
          )}
          {addr?.reported_date && (
            <div className="text-gray-600 text-xs mt-1">
              Reported: {addr.reported_date}
            </div>
          )}
        </td>
      </tr>
    ))}
  </tbody>
</table>

            </div>
          </div>
        </div>
      ) : ""}

      <div className='flex justify-center'>
        <div className="flex flex-col items-center bg-gray-200 rounded-md shadow-lg shadow-blue-800 md:w-3/4 w-full p-1">
          <h1 className="font-bold text-2xl text-red-600 underline mb-2">Instructions</h1>
          <h2 className="text-xl font-bold text-center text-gray-800 mb-2 underline">How to get Best Financial Credit Score?</h2>
         
          <ul className="list-decimal list-inside text-left text-gray-700">
            <li className=''>
              <strong>Direct Score Check:</strong> Enter mobile & name, then click "Check Score" directly.
            </li>
            <li>
              <strong>Manual Score Check:</strong> First verify the mobile number. After successful verification, you can check the score.
            </li>
            <li>Enter the Mobile Number which is registered in credit bureau company.</li>
            <li>Enter the correct name in Direct Score check/ Mannual check First & Last Name.</li>
            <li>The score check service only provides the credit Score of consumer.</li>
            <li>If you didn't get the score means you should try with different mobile number or in another bureau company.</li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default CheckScorePrefill






const MobileDataModal = ({
  mobileResponseData,
  onClose,
  setAfterMobName,
  VerifyContinue
}) => {
  const rootData = mobileResponseData?.data || {};

  setAfterMobName(rootData?.name);

  const addresses = rootData?.address || [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-3 rounded-lg shadow-2xl w-[90%] max-w-3xl max-h-[95vh] overflow-y-auto space-y-1">
        <div className='flex justify-between'>
          <h2 className="text-2xl font-bold text-blue-700 border-b">Consumer Verification Details</h2>
          <button onClick={onClose} className="text-2xl text-red-600 hover:text-red-800">❌</button>
        </div>
        {rootData?.name && (
          <div className="w-full flex flex-col items-center mb-2">
            <h3 className='text-xl text-green-600 font-semibold text-center'>Found In Experian</h3>
            <Link
              to="/ExperianScore2"
              className="flex items-center bg-green-700 hover:bg-green-800 text-white font-semibold py-2 px-4 gap-2 rounded transition duration-300 text-sm sm:text-base"
            >
              Result Found in Experian, Check Credit details in Experian for better result
              <FaHandPointLeft className="text-lg" />
            </Link>
          </div>
        )}


        {rootData?.idspay_message && (
          <div
            className={`flex justify-center border-2 p-1 rounded-lg ${rootData?.idspay_message === 'success' ? 'bg-green-100 border-green-300' : 'bg-red-100 border-red-300'
              }`}
          >
            <p
              className={`text-md font-serif ${rootData?.idspay_message === 'success' ? 'text-green-600' : 'text-red-500'
                }`}
            >
              {rootData.idspay_message}
            </p>
          </div>
        )}

        {/* Personal Info */}
        <div className="bg-blue-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-blue-600 mb-1">Personal Info</h3>
          <div className="grid grid-cols-2 gap-1 text-sm">
            <p><strong>Full Name:</strong> {rootData?.name || "N/A"}</p>
            <p><strong>DOB:</strong> {rootData?.dob || "N/A"}</p>
            <p><strong>Gender:</strong> {rootData?.gender || "N/A"}</p>
            <p><strong>PAN:</strong> {rootData?.pan || "N/A"}</p>
            <p><strong>Email:</strong> {rootData?.email || "N/A"}</p>
          </div>
        </div>

        {/* Addresses */}
        <div className="bg-yellow-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-yellow-600 mb-2">Addresses</h3>
          {addresses.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-sm border border-gray-300 rounded-md">
                <thead className="bg-yellow-100 text-gray-700">
                  <tr>
                    <th className="border px-2 py-1 text-left">Address #</th>
                    <th className="border px-2 py-1 text-left">Full Address</th>
                    <th className="border px-2 py-1 text-left">State</th>
                    <th className="border px-2 py-1 text-left">Postal Code</th>
                  </tr>
                </thead>
                <tbody>
                  {addresses.map((address, index) => (
                    <tr key={index} className="border-t">
                      <td className="border px-2 py-1">Address {index + 1}</td>
                      <td className="border px-2 py-1">
                        {[address?.first_line_of_address, address?.second_line_of_address, address?.third_line_of_address]
                          .filter(Boolean)
                          .join(', ')}
                      </td>
                      <td className="border px-2 py-1">{address?.state || 'N/A'}</td>
                      <td className="border px-2 py-1">{address?.postal_code || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-sm">No address information available.</p>
          )}
        </div>

        {/* Footer Buttons */}
        <div className='flex justify-center gap-3 mt-3'>
          <button
            onClick={VerifyContinue}
            className="bg-green-500 text-white px-4 py-1 rounded-md hover:bg-green-600 transition"
          >
            Verify & Continue
          </button>
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-1 rounded-md hover:bg-red-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};